import { container, primaryColor } from "assets/jss/material-kit-react.js";

const footerStyle = {
  block: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block"
  },
  pointer:{
    cursor:"pointer !important"
  },
  left: {
    float: "left!important",
    display: "block",

  },
  container:{
    display: "block",

  },
  right: {
    padding: "15px 0",
    margin: "0",
    float: "right!important",
    textAlign:'left'
  },
  footer: {
    //padding: "0.9375rem 0",
    textAlign: "center",
    display: "flex",
    zIndex: "2",
    position: "relative"
  },
  a: {
    color: primaryColor,
    textDecoration: "none",
    backgroundColor: "transparent"
  },
  footerWhiteFont: {
    "&,&:hover,&:focus": {
      color: "#FFFFFF"
    }
  },
  container,
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto"
  },
  icon: {
    width: "18px",
    height: "18px",
    position: "relative",
    top: "3px"
  },
  footerLogo:  {
    width: "120px",
    height: "140px",
    backgroundColor:"White",
    margin: "5px",
    textAlign: "center",
    padding: "5px",
    borderRadius: "10px",
    float:"right",
    "& img": {
      width: "100%"
    },
    "& a": {
      width: "100%"
    }
  },
  footerItem:{
    color: "inherit",
    //padding: "2px",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    textDecoration: "none",
    color: "#222",
    "&:hover,&:focus": {
      color: "#3f51b5"
    }
  },
  footerList:{
    //paddingLeft:"20px"
    
  },
  container:{
marginTop:"40px",
marginBottom:"40px",
marginLeft:"auto",
marginRight:"auto",
maxWidth:"90%"
  },
  left:{
    textAlign:"right"
  },
  right:{
    textAlign:"left"
  },
  center:{
    textAlign:"center"
  },
  ltr:{
direction:"rtl"
  },
  copyright:{
    marginTop:"40px",
    fontWeight: "500",
    fontSize: "11px",
    textTransform: "uppercase",
    textDecoration: "none",
    color: "#222",
  }
};
export default footerStyle;
